import { FragmentOf, gql } from '@/utilities/gql';

export const NARRATIVE_VALUATOR_COMPANY_FRAGMENT = gql(`
  fragment NarrativeValuatorCompanyFields on Company @_unmask {
    id
    name
    tickerSymbol
    uniqueSymbol
    data {
      marketCap
      currencyInfo
    }
    analysisFuture {
      revenueGrowthAnnual
      forwardPe1Y
    }
    info {
      url
    }
    primaryIndustry {
      name
      friendlyName
      industryAverages {
        name
        value
      }
    }
    secondaryIndustry {
      name
      friendlyName
      industryAverages {
        name
        value
      }
    }
    analysisValue {
      intrinsicValue
      pe
      lastSharePrice
      npvPerShare
    }
    analysisPast {
      netIncome
      netIncomeMargin
      revenue
      netIncomeLtmHistory
      revenueLtmHistory
    }
    analysisMisc {
      sharesOutstandingSingleGrowth1Y
    }
    canonicalURL
    timeSeries(startDate: "1970-01-01", endDate: "2200-01-01") {
      revenue
      totalSharesOutstanding
      date
    }
  }
`);

export type NarrativeValuatorCompany = FragmentOf<
  typeof NARRATIVE_VALUATOR_COMPANY_FRAGMENT
>;
